export default "__VITE_ASSET__jfMxXq8o__"